//Boilerplate
import { withRouter } from "react-router-dom";

//OurStuff
import { RoleRights } from 'components/User';
export default withRouter((RoleRights));
